<script setup lang="ts">
import { CtaExchangeRates, CtaExchangeRatesSkeleton } from '~/components/ui/cta-exchange-rates'

const { data: fetchedRates } = await useLazyFetch('/api/rates/widgets-cached', {
  server: false,
  default: () => null
})

const CURRENCIES = ['usd', 'eur', 'kzt', 'rub'] as const

const data = computed(() => {
  const rates = fetchedRates.value?.averageRatesToday
  return Object.fromEntries(
    CURRENCIES.map((currency) => [
      currency,
      {
        buyValue: rates?.[`buy_${currency}`] ? Number(rates[`buy_${currency}`]) : null,
        sellValue: rates?.[`sell_${currency}`] ? Number(rates[`sell_${currency}`]) : null
      }
    ])
  )
})
</script>

<template>
  <ClientOnly>
    <!-- Keep the skeleton until the rates arrive: an empty block is shorter and flashes -->
    <CtaExchangeRates v-if="fetchedRates" :rates="data" />
    <CtaExchangeRatesSkeleton v-else />
    <template #fallback>
      <CtaExchangeRatesSkeleton />
    </template>
  </ClientOnly>
</template>
